import { Directive, ElementRef, HostListener, Input } from '@angular/core';

const IndicatorStyles = {
  color: '#00bdb4',
  display: 'flex',
  fontSize: '.8em',
  order: '9999',
  fontWeight: 'bold',
};

@Directive({
  selector: '[limitPreview]',
})
export class LimitPreviewDirective {
  indicator;

  @HostListener('window:resize')
  public onResize() {
    this.limitPreview();
  }

  constructor(private el: ElementRef) {
    this.indicator = document.createElement('span');
    this.indicator.classList.add('previewIndicator');
    Object.assign(this.indicator.style, IndicatorStyles);
    this.el.nativeElement.appendChild(this.indicator);
    this.limitPreview();
  }

  limitPreview() {
    setTimeout(() => {
      if (this.el.nativeElement) {
        const indicatorWidth = 55;

        let availableWidth = 0;

        if (this.el.nativeElement.offsetParent) {
          availableWidth =
            this.el.nativeElement.offsetParent.offsetWidth - indicatorWidth;
        }

        const children: HTMLElement[] = Array.from(
          this.el.nativeElement.children
        );

        let usedWidth = 0;
        let itemsDisplayed = 0;

        children.forEach(child => {
          if (usedWidth + child.offsetWidth <= availableWidth) {
            usedWidth += child.offsetWidth;
            itemsDisplayed++;
            child.style.display = 'flex';
          } else {
            child.style.display = 'none';
          }
        });

        const itemsLeft = children.length - itemsDisplayed;

        if (itemsLeft > 0) {
          this.indicator.innerText = `+${itemsLeft}`;
          this.indicator.style.display = IndicatorStyles.display;
        } else {
          this.indicator.style.display = 'none';
        }
      }
    });
  }
}
